import axios from "axios";
import { SETTING_FAIL, SETTING_REQUEST, SETTING_SUCCESS } from "../constats/setting.constant";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";

export const getSetting = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: SETTING_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }settings`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch(setSetting(data));
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: SETTING_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: SETTING_FAIL,
                payload: err.response && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}

export const setSetting = (setting) => async(dispatch) => {
    dispatch({
        type: SETTING_SUCCESS,
        payload: setting
    });
}